/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles'

import { Paper } from '@material-ui/core'

import DateFnsUtils from '@date-io/date-fns'; 
import { DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";

import { format, startOfYear,addQuarters, startOfQuarter, endOfQuarter, isWithinInterval, isBefore, isAfter, isSameDay } from 'date-fns';

const styles = theme => ({
    selected : {
        display : 'flex',
        flexDirection : 'row',
        justifyContent : 'center',
        alignItems : 'center',
        backgroundColor : '#2296f3',
        color : '#FFFFFF'
    },
    unselected : {
        display : 'flex',
        flexDirection : 'row',
        justifyContent : 'center',
        alignItems : 'center',
        backgroundColor : '#FFFFFF',
        color : '#000000'
    },
    disabled : {
        display : 'flex',
        flexDirection : 'row',
        justifyContent : 'center',
        alignItems : 'center',
        backgroundColor : '#F0F0F0',
        color : '#000000'
    }
})

const half_years = [1, 2]

class HalfYearPicker extends Component {
    state = {  }

    getYear = (date_string) => {
        if (date_string !== null) {
            console.log("Quarter Picker date: ", date_string)
            let start_date_of_year = format(startOfYear(new Date(date_string)), "yyyy-MM-dd'T'HH:mm:ssxxx")
            return start_date_of_year
        } else {
            return null
        }
    }

    getHalfYearStartDate = (start_date_of_year, half_year_number) => {
        let start_date_of_quarter = format(startOfQuarter(addQuarters(new Date(start_date_of_year), (half_year_number - 1) * 2)), "yyyy-MM-dd'T'HH:mm:ssxxx")
        return start_date_of_quarter
    }

    getHalfYearEndDate = (start_date_of_year, half_year_number) => {
        let num_of_quarters
        if (half_year_number === 1) {
            num_of_quarters = 1
        } else {
            num_of_quarters = 3
        }
        let end_date_of_quarter = format(endOfQuarter(addQuarters(new Date(start_date_of_year), num_of_quarters)), "yyyy-MM-dd'T'HH:mm:ssxxx")
        return end_date_of_quarter
    }

    getHalfYearState = (date_string, half_year_number) => {
        let start_date = this.getHalfYearStartDate(this.getYear(date_string), half_year_number)
        console.log("Half Year Start Date: ", format(new Date(start_date), "dd MM yyyy"))
        let end_date = this.getHalfYearEndDate(this.getYear(date_string), half_year_number)
        console.log("Half Year End Date: ", format(new Date(end_date), "dd MM yyyy"))
        let date = new Date(date_string)

        if (isWithinInterval(date, {start : new Date(start_date), end : new Date(end_date)})) {
            return "selected"
        }

        if (this.props.maxDate) {
            if (isBefore(new Date(this.props.maxDate), new Date(start_date)) || isSameDay(new Date(this.props.maxDate), new Date(start_date))) {
                return "disabled"
            }
        }

        return "unselected"
    }

    renderHalfYears = () => {
        const { classes } = this.props
        if (this.getYear(this.props.date) !== null) {
            let half_year = half_years.map(hy => {
                let hy_state = this.getHalfYearState(this.props.date, hy)
                return (
                    <Paper 
                        className = {classes[hy_state]} 
                        square 
                        style = {{width : '200px', height : '100px', marginTop : '5px', marginRight : '5px', cursor : 'pointer'}}
                        onClick = {() => {
                            if (hy_state !== 'disabled') {
                                this.props.onChange(this.getHalfYearStartDate(this.getYear(this.props.date), hy))
                            }
                        }}
                    >{"HY" + hy}</Paper>
                )
            })
    
            return half_year
        }
    }

    getValue = (date_string) => {
        if (date_string !== null) {
            let value = format(new Date(this.props.date), "yyyy-MM-dd'T'HH:mm:ssxxx")
            return value
        } else {
            return null
        }
    }

    render() {
        return (
            <div style = {{width : '100%'}}>
                <div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                            autoOk
                            id = "start_year"
                            variant="inline"
                            openTo="year"
                            label = {this.props.label}
                            helperText = {this.props.helperText}
                            minDate = {this.props.minDate}
                            maxDate = {this.props.maxDate}
                            disableFuture = {this.props.disableFuture}
                            views={["year"]}
                            value = {this.getValue(this.props.date)}
                            onChange = {(value) => {
                                if (this.props.maxDate) {
                                    if (isBefore(startOfYear(new Date(value)), new Date(this.props.maxDate))) {
                                        this.props.onChange(format(startOfYear(new Date(value)), "yyyy-MM-dd'T'HH:mm:ssxxx"))
                                    }
                                } else {
                                    this.props.onChange(format(startOfYear(new Date(value)), "yyyy-MM-dd'T'HH:mm:ssxxx"))
                                }
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </div>
                <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>{this.renderHalfYears()}</div>
            </div>
        );
    }
}

export default withStyles(styles)(HalfYearPicker);